// extracted by mini-css-extract-plugin
module.exports = {"container":"ai-z","copy":"bi-z","field":"ci-z","error":"di-z","disabled":"ei-z","termsContainer":"fi-z","termsHeading":"gi-z","termsCopy":"hi-z","submit":"ii-z","srOnly":"ji-z"};